import { FormValues } from "./schema"

export enum FormatKey {
  VSCODE = "vscode",
  SUBLIME = "sublime",
  ATOM = "atom",
  ZED = "zed",
  JUPYTER = "jupyter",
}

export const DEFAULT_STATE: FormValues = {
  description: "",
  tabTrigger: "",
  snippet: "",
  format: FormatKey.VSCODE,
  scope: undefined,
}
